import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import "../styles/Formularios.css";
import InputPuertos from "./InputPuertos";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";
import InputNombreSwitch from "./InputNombreSwitch";
import InputMac from "./InputMac";
import { isValidMac } from "../utils/validacionMac";



function RegistrarSwitches() {
    const { setModuloActual, setSubModuloActual, permisos, logout } = useGlobal();
    const [nomSwitch, setNomSwitch] = useState("");
    const [serieSw, setSerieSw] = useState("");
    const [mac, setMac] = useState("");
    const [puertos, setPuertos] = useState("");
    const [idSede, setIdSede] = useState("");
    const [idEdificio, setIdEdificio] = useState("");
    const [idNivel, setIdNivel] = useState("");
    const [descSwitch, setDescSwitch] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [success, setSuccess] = useState(false);
    const apiFetch = useApiFetch();
    const tienePermisoRegistrar = permisos.includes(30); // id_permiso=30; "Registrar switches"

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje("");

        // Validaciones
        if (!nomSwitch || !serieSw || !mac || !puertos || !idSede || !idEdificio || !idNivel || !descSwitch) {
            return setMensaje("Todos los campos son obligatorios.");
        }

        if (nomSwitch.length !== 9) {
            return setMensaje("El nombre del switch debe tener exactamente 9 caracteres.");
        }

        if (descSwitch.length > 255) {
            return setMensaje("El texto no debe superar los 255 caracteres.");
        }

        if (serieSw.length > 30) {
            return setMensaje("La serie no debe exceder de 30 caracteres.");
        }

        if (mac.length !== 17) {
            return setMensaje("La dirección MAC es incorrecta");
        }

        if (!isValidMac(mac)) {
            return setMensaje("La dirección MAC es incorrecta");
        }

        if (isNaN(puertos) || puertos <= 0) {
            return setMensaje("El número de puertos debe ser válido y mayor a 0.");
        }

        // Envio de datos para crear la tabla y registrar el switch
        try {

            const data = await apiFetch("registrar_switch.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    nomSwitch,
                    serieSw,
                    mac,
                    puertos: Number(puertos),
                    idSede,
                    idEdificio,
                    idNivel,
                    descSwitch
                })
            }, logout);

            if (data.status === "ok") {
                setNomSwitch("");
                setSerieSw("");
                setMac("");
                setPuertos("");
                setIdSede("");
                setIdEdificio("");
                setIdNivel("");
                setDescSwitch("");
            }

            if (data.status === "ok") {
                setMensaje(data.message);
                setSuccess(true);
                setTimeout(() => {
                    setModuloActual("Red");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setMensaje("\u274C " + (data.message || "Error al registrar el switch."));
            }
        } catch {
            setMensaje("Error de conexión con el servidor.");
        }
    };

    // Este useEffect siempre se ejecuta, pero solo programa el timer si hay error o success
    useEffect(() => {
        if (mensaje) {
            const timer = setTimeout(() => {
                setMensaje("");
                setSuccess(false); // Volver a boolean
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [mensaje]);

    if (!tienePermisoRegistrar) {
        return <p>Acceso denegado. No tiene permiso para registrar switches.</p>;
    }

    // Captura de datos reutilizando otros componentes
    return (
        <div className="sesion-form">

            {mensaje && <div className={success ? "success" : "error"}>{mensaje}</div>}

            <form onSubmit={handleSubmit}>
                <InputNombreSwitch
                    value={nomSwitch}
                    setValue={setNomSwitch}
                    label="Nombre del switch"
                    placeholder="sw1_ep_pb"
                    title="Respete la nomenclatura"
                />

                <InputGenerico
                    value={serieSw}
                    setValue={setSerieSw}
                    label="Serie del switch"
                    maxLength={30}
                    allowedChars="0-9A-Z"
                    transform="uppercase"
                    placeholder="FDO654387"
                    title="Máximo 30 caracteres"
                />

                <InputMac
                    value={mac}
                    onChange={setMac}
                    label="Dirección MAC"
                    placeholder="AA:BB:CC:DD:EE:FF"
                    title="Ingrese la dirección MAC del dispositivo"
                />

                <InputSelectGenerico
                    idSeleccionado={idSede}
                    setIdSeleccionado={setIdSede}
                    label="Sede"
                    apiUrl={`consultar_sedes.php`}
                    valueField="id_sede"
                    displayField="acronimo"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione una sede"
                />

                <InputSelectGenerico
                    idSeleccionado={idEdificio}
                    setIdSeleccionado={setIdEdificio}
                    label="Edificio"
                    apiUrl={`consultar_edificios.php`}
                    valueField="id_edificio"
                    displayField="edificio"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un edificio"
                />

                <InputSelectGenerico
                    idSeleccionado={idNivel}
                    setIdSeleccionado={setIdNivel}
                    label="Nivel"
                    apiUrl={`consultar_niveles.php`}
                    valueField="id_nivel"
                    displayField="nivel"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un piso o nivel"
                />

                <InputPuertos
                    puertos={puertos}
                    setPuertos={setPuertos}
                    label="Número de puertos"
                    readOnly={false}
                />

                <InputGenerico
                    value={descSwitch}
                    setValue={setDescSwitch}
                    label="Descripción del switch"
                    maxLength={255}
                    allowedChars="a-zA-Z0-9 _\-.,áéíóúÁÉÍÓÚÑñ"
                    placeholder="Escriba su texto aquí"
                    title="Máximo 255 caracteres"
                />

                <div className="form-buttons">
                    <button type="submit" disabled={success}>Registrar</button>
                </div>

            </form>

        </div>
    );
}

export default RegistrarSwitches;